export default "__VITE_ASSET__BJaXhCoF__"